var _feGaussianBlur, _feGaussianBlur2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg866",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs870"
  }, /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter3651",
    x: -0.038548535,
    y: -0.032870765,
    width: 1.0770971,
    height: 1.0657415
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur4835",
    stdDeviation: "1 1",
    result: "fbSourceGraphic",
    in: "fbSourceGraphic"
  })), _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur4989",
    stdDeviation: "2 2",
    result: "blur",
    in: "fbSourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g872"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      filter: "url(#filter3651)"
    },
    d: "M 45.656972,159.01913 V 77 h 22.505845 22.5049 v 81.75 82.29 h -22.760745 -22.25 z M 179.65669,241.04 179.65697,153.33333 179.65669,67 109.15697,67.000315 H 38.656972 V 44.5 22.000373 l 73.249998,0.02445 c 46.89775,0.01565 77.75,-0.01223 77.75,-0.01223 18.08937,0.123548 35.84064,20.340647 35.77736,38.834805 0,0 0,33.668132 0,93.152602 v 87.04 H 203.09227 Z M 99.655433,177.98992 V 133 h 71.001537 v 44.98992 z",
    id: "path1164"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M 43.656973,157.01913 V 75 h 22.505844 22.5049 v 81.75 82.29 H 65.906977 43.656973 Z M 177.65669,239.04 177.65697,151.33333 177.65669,65 107.15697,65.000315 H 36.656973 V 42.5 20.000373 l 73.249997,0.02445 c 46.89775,0.01565 77.75,-0.01223 77.75,-0.01223 18.08937,0.123548 35.84064,20.340647 35.77736,38.834805 0,0 0,33.668132 0,93.152602 v 87.04 H 201.09227 Z M 97.655437,175.98992 V 131 h 71.001533 v 44.98992 z",
    id: "path4119"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.68b134d63ac054a55dec14f70cd3e400.svg";
export { ForwardRef as ReactComponent };